module.exports = __webpack_public_path__ + "static/img/top-bg.b3866b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/top-bg.png
// module id = X+8K
// module chunks = 0